/**
 * PageWrap — gemeinsamer Seiten-Container (aus den Design-Prototypen).
 *
 * Zentriert den Inhalt in einer schmalen Spalte (`Container maxWidth="sm"`) mit
 * der Prototyp-Polsterung `py:2, px:2`. Die `center`-Variante (nur Login) füllt
 * die Höhe und zentriert den Inhalt vertikal/horizontal.
 *
 * Hinweis für Aufrufer: Bei der NICHT-zentrierten Variante gehört die sticky
 * `AppHead`-Leiste NICHT in den Container (sie läuft über die volle Breite).
 * Rendere `<AppHead/>` als Geschwister VOR `<PageWrap>`.
 */

import Container from "@mui/material/Container";
import type { Breakpoint } from "@mui/material/styles";
import type { ReactNode } from "react";

export default function PageWrap({
  children,
  center = false,
  max = "sm",
}: {
  children: ReactNode;
  center?: boolean;
  max?: Breakpoint;
}) {
  return (
    <Container
      maxWidth={max}
      sx={{
        py: 2,
        px: 2,
        ...(center
          ? {
              minHeight: "100dvh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }
          : {}),
      }}
    >
      {children}
    </Container>
  );
}
